export const getNameFromVendor = contact => {
  const trimmed = contact ? contact.trim() : null;
  if (!trimmed) {
    return '';
  }
  return trimmed.split(' ')[0];
};
